import { useEffect } from 'react';
import {
  selectTemplates,
  selectTemplatesError,
  selectTemplatesIsCreating,
  selectTemplatesIsLoading,
  useTemplatesStore,
} from '@/store/templatesSlice';

export function useTemplatesPage() {
  const templates = useTemplatesStore(selectTemplates);
  const isLoading = useTemplatesStore(selectTemplatesIsLoading);
  const isCreating = useTemplatesStore(selectTemplatesIsCreating);
  const error = useTemplatesStore(selectTemplatesError);
  const fetchTemplates = useTemplatesStore((s) => s.fetchTemplates);
  const createTemplate = useTemplatesStore((s) => s.createTemplate);

  useEffect(() => {
    void fetchTemplates();
  }, [fetchTemplates]);

  return { templates, isLoading, error, isCreating, createTemplate };
}
